<template>
  <div>
    <el-form ref="formRef" :model="versionForm" label-width="160px">
      <el-form-item label="版本号：">
        <el-input v-model="versionForm.version" placeholder="请输入版本号" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="版本号id：">
        <el-input v-model="versionForm.versionId" placeholder="请输入版本号id" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="平台：">
        <el-select v-model="platformType" value-key="value" placeholder="请选择" style="width: 12em;" @change="platformChange">
          <el-option v-for="item in platformArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="渠道：">
        <el-select v-model="channelId" value-key="value" placeholder="请选择" style="width: 12em;" filterable>
          <el-option v-for="item in channelArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
<!--      <el-form-item label="苹果支付开启时间：">-->
<!--        <time-picker :value="versionForm.startTime?new Date('2018-01-01 ' + versionForm.startTime):new Date()" @time="getStartTime($event)"></time-picker>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="苹果支付结束时间：">-->
<!--        <time-picker :value="versionForm.endTime?new Date('2018-01-01 ' + versionForm.endTime):new Date()" @time="getEndTime($event)"></time-picker>-->
<!--      </el-form-item>-->
      <el-form-item label="苹果审核版本id：">
        <el-input v-model="versionForm.appleId"  style="width:24em;" placeholder="请输入苹果审核版本id"></el-input>
      </el-form-item>
<!--      <el-form-item label="渠道：">-->
<!--        <el-input v-model="versionForm.channel"  style="width:24em;" placeholder="请输入渠道名称"></el-input>-->
<!--      </el-form-item>-->
      <el-form-item label="下载链接：">
        <el-input type="textarea" v-model="versionForm.url"  style="width:24em;" placeholder="请输入下载链接"></el-input>
      </el-form-item>
      <el-form-item label="描述：">
        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6}" v-model="versionForm.descp" style="width:24em;"  placeholder="请添加描述"></el-input>
      </el-form-item>
      <el-form-item label="备注：">
        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6}" v-model="versionForm.remark" style="width:24em;" placeholder="请添加备注"></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="submit" v-loading="loading">提交</el-button>
    </div>
  </div>
</template>

<script>
import {getFormData, postFormData} from "@/api/api"
import {addOrUpdateVersion, getAllChannelList} from "@/api/url";
import TimePicker from "@/components/TimePicker";
import {urlReg} from "@/assets/shared/reg-constant";

export default {
name: "VersionDialog",
  components: { TimePicker },
  props: {
    value: Object
  },
  data() {
    return {
      versionForm: this.value.versionForm,
      idx: this.value.ids,
      loading: false,

      platformArray: [
        {label:'Android', value: 1},
        {label:'鸿蒙', value: 4},
        {label:'iOS', value: 2}
      ],

      platformType: this.value.versionForm.platformType?this.value.versionForm.platformType: -1,

      //渠道
      channelArray: [],
      channelId: this.value.versionForm.channelId,

      listAll: [],
      iosList: [],
      androidList: [],
      harmonyList: [],

    }
  },
  methods: {

    /**
     * 获取时间
     * @author Dave
     */
    getStartTime(el) {
      this.versionForm.startTime = el;
    },
    getEndTime(el) {
      this.versionForm.endTime = el;
    },

    cancel() {
      this.$emit("close");
    },

    submit() {
      if(!this.versionForm.version) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '版本号不能为空',
          type: 'warning'
        });
        return false
      }
      if(this.versionForm.versionId == '' || this.versionForm.versionId == undefined) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '版本号id不能为空',
          type: 'warning'
        });
        return false
      }
      if(this.versionForm.platformType == 1 && this.versionForm.appleId != '0') {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '当前选择的平台是Android,请将苹果审核id设为0',
          type: 'warning'
        });
        return false
      }
      if(this.versionForm.platformType == 4 && this.versionForm.appleId != '0') {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '当前选择的平台是鸿蒙,请将苹果审核id设为0',
          type: 'warning'
        });
        return false
      }
      if(!this.channelId) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '渠道不能为空',
          type: 'warning'
        });
        return false
      }
      if (!urlReg.test(this.versionForm.url) && this.versionForm.url) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: "请输入正确的下载链接",
          type: 'warning'
        });
        return false
      }
      if(!this.versionForm.descp) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '描述不能为空',
          type: 'warning'
        });
        return false
      }
      let param = {}
      param['id'] = this.versionForm.id?this.versionForm.id:0;
      param['version'] = this.versionForm.version;
      param['versionId'] = this.versionForm.versionId;
      param['appleId'] = this.versionForm.appleId;
      param['appleId'] = this.versionForm.appleId;
      // param['platformType'] = this.versionForm.platformType;
      // param['startTime'] = this.versionForm.startTime;
      // param['endTime'] = this.versionForm.endTime;
      param['channelId'] = this.channelId;
      param['url'] = this.versionForm.url;
      param['descp'] = this.versionForm.descp;
      param['remark'] = this.versionForm.remark;
      postFormData(addOrUpdateVersion, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },


    //获取渠道
    getChannel() {
      let _this = this
      let param = {};
      getFormData(getAllChannelList, param).then(function(data){
        let dataList = data.data
        dataList.map(item => {
          let obj = {}
          if(item.platformType == 1) {
            obj.label = item.channel
            obj.value = item.id
            _this.androidList.push(obj)
          }else if(item.platformType == 2) {
            obj.label = item.channel
            obj.value = item.id
            _this.iosList.push(obj)
          }else if(item.platformType == 4) {
            obj.label = item.channel
            obj.value = item.id
            _this.harmonyList.push(obj)
          }
        })
        _this.listAll = [..._this.androidList, ..._this.iosList, ... _this.harmonyList]
        _this.channelArray = [..._this.channelArray, ..._this.androidList, ..._this.iosList, ... _this.harmonyList]

        if (this.platformType == 1) {
          this.channelArray = [...this.channelArray, ...this.androidList]
        } else if(this.platformType == 2) {
          this.channelArray = [...this.channelArray, ...this.iosList]
        } else if(this.platformType == 4) {
          this.channelArray = [...this.channelArray, ...this.harmonyList]
        }

      })
    },

    platformChange() {
      this.channelArray = []
      this.channel = ''
      if (this.platformType == 1) {
        this.channelArray = [...this.channelArray, ...this.androidList]
      } else if(this.platformType == 2) {
        this.channelArray = [...this.channelArray, ...this.iosList]
      } else if(this.platformType == 4) {
        this.channelArray = [...this.channelArray, ...this.harmonyList]
      }
    }

  },

  mounted() {
    this.getChannel()
  }

}
</script>

<style scoped>

</style>
